import React from "react";
import { Dialog, DialogActions, DialogContent, DialogTitle, Button } from "@mui/material";

// Defaults keep the original delete look; add/edit/upload pass their own label.
const ConfirmDialog = ({
  open,
  onClose,
  onConfirm,
  title,
  content,
  confirmLabel = "Delete",
  confirmColor = "error",
}) => {
  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>{content}</DialogContent>
      <DialogActions>
        <Button variant="contained" onClick={onClose}>Cancel</Button>
        <Button color={confirmColor} variant="outlined" onClick={onConfirm}>{confirmLabel}</Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmDialog;
